import { useContext, useEffect } from 'react';

import { Form } from '@zillow/constellation-10';

import { ModularListingContext } from '../../../../../containers/CreateListingPage/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../../constants/WizardConstants';

import WizardAlert from '../../../../WizardAlert';
import actions from '../../../../../containers/CreateListingPage/actions';
import MinCreditScoreFormFieldContainer from '../../../MinCreditScoreFormFieldContainer';

import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../../styles/wizard';

const propTypes = {};
const defaultProps = {};

const MinimumCreditScoreFormSectionContainer = () => {
  const {
    modularListingState: { serverErrorObj },
    reducerDispatch,
  } = useContext(ModularListingContext);

  useEffect(() => {
    actions.updateAnyProperty({
      reducerDispatch,
      data: {
        isInModalState: true,
        isSaveComplete: false,
        shouldSaveOnBlur: false,
      },
    });

    return () => actions.updateShouldSaveOnBlur({ reducerDispatch, shouldSaveOnBlur: true });
  }, [reducerDispatch]);

  return (
    <WizardFormSectionContainer data-testid="MinimumCreditScoreFormSectionContainer">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />

      <WizardHeading level={1} textStyle="heading-sm">
        What&apos;s your preferred minimum credit score?
      </WizardHeading>

      <WizardBody>
        Credit scores fluctuate and don&apos;t show a history of on-time rent payments, so use this with other criteria
        for a more complete financial picture.
      </WizardBody>

      <Form asChild={true} onSubmit={(event) => event.preventDefault()}>
        <>
          <MinCreditScoreFormFieldContainer />
        </>
      </Form>
    </WizardFormSectionContainer>
  );
};

MinimumCreditScoreFormSectionContainer.propTypes = propTypes;
MinimumCreditScoreFormSectionContainer.defaultProps = defaultProps;

export default MinimumCreditScoreFormSectionContainer;
